import React, { createContext, useContext } from "react";
import { useConvoSearch, ConvoState } from "../hooks/useConvoSearch";

interface ConvoSearchContextValue {
  state: ConvoState;
  search: (query: string) => void;
  reset: () => void;
}

const ConvoSearchContext = createContext<ConvoSearchContextValue | null>(null);

export const ConvoSearchProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = useConvoSearch();
  return (
    <ConvoSearchContext.Provider value={value}>
      {children}
    </ConvoSearchContext.Provider>
  );
};

export const useConvoSearchContext = (): ConvoSearchContextValue => {
  const ctx = useContext(ConvoSearchContext);
  if (!ctx) {
    throw new Error(
      "useConvoSearchContext must be used within ConvoSearchProvider"
    );
  }
  return ctx;
};
